<template>
  <div>
    <h1>My Page</h1>
    <p>ログイン後のページです。</p>
    <div>
      Hello: <pre id="email"></pre>
      Access token: <pre id="access-token"></pre>
      ID token: <pre id="id-token"></pre>
      Refresh token: <pre id="refresh-token"></pre>
    </div>
  </div>
</template>

<script>
// 標準モジュール
import { useRouter } from 'vue-router';
import { userManager, signOutRedirect } from "@/main.js";
import { onMounted } from 'vue';

// 外部モジュール

// 独自モジュール

export default {
  name: 'MyPage',
//   components: {
//     MurmurList,
//   },
  setup() {
    // ##########
    // ライフサイクル #
    // ##########
    onMounted (() => {
        userManager.signinCallback().then(function (user) {
          document.getElementById("email").textContent = user.profile?.email;
          document.getElementById("access-token").textContent = user.access_token;
          document.getElementById("id-token").textContent = user.id_token;
          document.getElementById("refresh-token").textContent = user.refresh_token;
      });
    })

    // ##########
    // 画面遷移 #
    // ##########
    const router = useRouter()

    const openPage = (target) => {
      router.push(`/${target}`)
    }

    // ##########
    // Login # 
    // ##########
     const logout = () => {
      // ログアウト処理をここに実装
      console.log("ログアウト処理を実行");
      document.getElementById("signOut").addEventListener("click", async () => {
        await signOutRedirect();
      });
      // 例: 成功したらログインページへ遷移
      router.push('/LoginPage');
    }

    // ##########
    // フォーム #
    // ##########
    const form = {
      username: '',
      password: '',
    };

    return {
        openPage,
        // ログアウト
        logout,
        // フォーム
        form,
    };
  },
}
</script>
